import type { VariantOption } from "../types/earmold.types";

export const getHasDisplayableVariantOption = (
	option?: VariantOption | null,
): boolean => {
	if (option === null || option === undefined) {
		return false;
	}
	if (typeof option.label !== "string") {
		return false;
	}
	return option.label.trim().length > 0;
};
